<template functional>
    <b-btn
        :active="props.active"
        :block="props.block"
        :class="[
            data.class,
            data.staticClass
        ]"
        :disabled="props.disabled"
        :href="props.href"
        :pressed="props.pressed"
        :replace="props.replace"
        :router-tag="props.routerTag"
        :size="props.size"
        :target="props.target"
        :to="props.to"
        :type="props.type"
        :tag="props.tag"
        :variant="props.variant"
        v-on="listeners"
    >
        <slot v-if="!props.processing" />
        <b-spinner
            v-else
            :label="props.label"
            :variant="props.spinnerVariant"
        />
    </b-btn>
</template>

<script>
export default {
    name: 'Button'
};
</script>

<style lang="scss">

</style>
